module.exports = __webpack_public_path__ + "media/mypage/images/flat/laptop-7f6f78aaaf80fc74cd099b90185a11dc.png";